export const ICON_PATHS = {
    routeStart: '/assets/icons/Untitled-1.png',
    routeEnd:  '/assets/icons/end-icon-sq.png',
    poiImage:  '/assets/icons/poi-image-icon.png',
}